import React from 'react';

import { IIconProps } from 'assets/icons/IconProps';

export const PlayIcon = ({
  width = 18,
  height = 18,
  stroke = '#FFFFFF',
  strokeWidth = 2,
}: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 18 18"
  >
    <path
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      d="M5.29076 14.7595L12.9415 9.84118C13.5538 9.44754 13.5538 8.55246 12.9415 8.15882L5.29076 3.24049C4.62525 2.81266 3.75 3.2905 3.75 4.08166V13.9183C3.75 14.7095 4.62525 15.1873 5.29076 14.7595Z"
    />
  </svg>
);
